import React,{useState} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { EleccostAdd } from '../../../apis/urls'

const AddeleCost = () => {

    const [table_num,setTable_num] = useState('');
    const [cost,setCost] = useState('');
    const [status,setStatus] = useState('');
    const [numerror,setnumerror] = useState(false);
    const [costerror,setcosterror] = useState(false);

    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/elecostlist")
        
    }


    const onFormClick = () => {

        let error = 0;

        if(cost === '')
        {
            setcosterror(true)
            error = 1;
        }

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                table_num :table_num,
                cost :cost,
                status :'ACTIVE'
            }
            
            const instance = axios.create({

                baseURL: EleccostAdd,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{
                
                let path = 'newPath'; 
                navigate("/elecostlist")
            
            }).catch((error) =>{
                
                //console.log('error',error.message)
            });

        }
    }
    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New Electricity Cost</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/degreelist">Table Electricity Cost</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Electricity Cost</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="card formcard small">
                            <div className="card-body">
                                <div className="form-group">
                                    <label className="degreehead">Cost</label>
                                    <input type="text" className="form-control bg-dark dark-theme showtext" value={cost} onChange={e => {setCost(e.target.value)}} placeholder="Enter the Cost" id="name"></input>
                                    {
                                       costerror
                                       ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Table Cost</div>
                                       :null
                                    }
                                </div>
                                {/* <div className="form-group">
                                    <label className="degreehead">Status </label>
                                        <select  value={status} onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option >Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                        </select>
                                </div> */}
                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                <div className="form-group text-right">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={onFormClick} className="btn btn-primary btn-gisa" type="button">Create</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </form>


                </div>
            </aside>
        </div>
    )
}

export default AddeleCost;